import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import ParentButton from './ParentButton'
import { Pills } from '../ProfilePanel/ProfilePanel.styles.jsx'

const BrotherContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: column;
  height: 105px;
  cursor: ${props => props.cursor && 'pointer'};
  @media (min-width:1024px) {
    height: 100px;
    padding-top: 0;
  }
`
const BrotherInfoContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
`

const BrotherPhoto = styled.div`
  background-image: ${props => props.profile_image ? 'url(' + props.profile_image + ')' : ''};
  background-size: cover;
  background-position: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: gray;
  @media (min-width:1024px) {
    width: 40px;
    height: 40px;
  }
  @media (min-width:1440px) {
    width: 40px;
    height: 40px;
  }
`
const BrotherName = styled.span`
  color: #EA3B3B;
  font-size: 14px;
  font-weight: bold;
  max-width: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
  @media (min-width:1024px) {
    font-size: 14px;
    max-width: 150px;
    white-space: normal;

  }
  @media (min-width:1440px) {
    font-size: 16px;
    max-width: 200px;
  }
`
const BrotherBD = styled.span`
  color: rgba(74,74,74,.5);
  font-size: 12px;
`
const BrotherInfo = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  margin-left: 10px;
  margin-top: 5px;
`

const ExtraInfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 4px 0 4px 0;
  width: 100%;
  font-weight: 600;
  padding-top: 10px;
`

const BrotherStatus = styled.div`
  color: #75B753;
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
`

const BrotherButton = props => (
  <ParentButton {...props} disabled={!props.inCenter} onClick={props.inCenter && props.onClick}>
    {props.center &&
    <BrotherContainer cursor={props.inCenter}>
      <BrotherInfoContainer>
        <BrotherPhoto profile_image={props.profile_image} />
        <BrotherInfo>
          <BrotherName>
            {props.name || ''}
          </BrotherName>
          <BrotherBD>
            {props.birth_date || ''}
          </BrotherBD>
        </BrotherInfo>
      </BrotherInfoContainer>
      <ExtraInfoRow>
        <Pills>{props.center.abbreviation || ''}</Pills>
        <BrotherStatus>{props.status.status || ''}</BrotherStatus>
      </ExtraInfoRow>
    </BrotherContainer>
    }
  </ParentButton>
)

BrotherButton.propTypes = {
  birth_date: PropTypes.string,
  center: PropTypes.object.isRequired,
  status: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
}

BrotherButton.defaultProps = {
  birth_date: '',
}

export default BrotherButton



// WEBPACK FOOTER //
// ./src/Components/CustomButtons/BrotherButton.jsx